import React, { Component } from "react";
// core components
import NavPills from "components/NavPills/NavPills.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import MUIDataTable from "mui-datatables";
import SearchIco from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.jsx";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import GridList from "@material-ui/core/GridList";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  fetchPortAll,
  fetchShipSearch,
  fetchShipTracker,
  fetchShipLine
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget } from "actions/portal";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import { pushLoader } from "../../actions/main";
import ReactExport from "assets/libs/react-export-excel";
import moment from "moment";
import { withRouter } from "react-router-dom";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Vessel Tracking ${moment().format('LLL')}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  }
});

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      shiptracker: [],
      selectedCategory: 0,
      loader: null
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true)
    this.setState({loader: true})
    fetchShipTracker(localStorage.getItem("id"))
      .then(response => {
        //this.props.pushLoader(false);
        this.setState({ shiptracker: response.data.results });
        this.props.pushLoader(false)
        this.setState({loader: false})
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  renderShipTracker = e => {
    return <MenuItem value={e.shipid}> {e.name} </MenuItem>;
  };

  handlecat = e => {
    this.setState({
      selectedCategory: e.target.value
    });

    fetchShipLine(e.target.value)
      .then(response => {
        if (response != null) {
          let datanya = [];
          for (var key in response.data) {
            var aa = _.values(response.data[key]);
            datanya.push({
              name: aa[5],
              shipid: aa[7],
              shiptype: this.getNameshiptype(aa[6]),
              dateCreated: aa[39],
              latitude: aa[3],
              longitude: aa[4]
            });
          }
          this.setState({ datatable: datanya });
        }
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shipid",
        label: "Shipid",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dateCreated",
        label: "DateCreated",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: true
        }
      }
    ];

    const options = {
      filter: false,
      search: false,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      onRowClick: e => {
        this.handleRowSelect(e);
      },
      textLabels: {
        body: {
          noMatch: this.state.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return <GridItem xs={12}>
        <div className={classes.content}>
          <GridItem xs={2}>
            <FormControl variant="outlined">
              <Select value={this.state.selectedCategory} onChange={this.handlecat}>
                <MenuItem value="0"> === choose vessel === </MenuItem>
                {this.state.shiptracker.map(this.renderShipTracker)}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={2}>
            <ExcelFile element={<Button color="primary" variant="contained" disabled={this.state.loader}>
                  Download as .xslx
                </Button>} filename={`${fileName}`} fileExtension="xslx">
              <ExcelSheet data={this.state.datatable} name="Sheet 1">
                <ExcelColumn label="Name" value="name" />
                <ExcelColumn label="Shipid" value="shipid" />
                <ExcelColumn label="Shiptype" value="shiptype" />
                <ExcelColumn label="DateCreated" value="dateCreated" />
                <ExcelColumn label="Latitude" value="latitude" />
                <ExcelColumn label="Longitude" value="longitude" />
              </ExcelSheet>
            </ExcelFile>
          </GridItem>
          <br />
          <GridItem xs={12}>
            <MUIDataTable data={this.state.datatable} columns={columns} options={options} />
          </GridItem>
        </div>
      </GridItem>;
  }
}

Tracking.propTypes = {
  pushLeftPanel: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget, pushLoader }
)(withStyles(styles)(Tracking)));
